export default __webpack_public_path__ + "static/media/external-link.2e59ae3f.svg";